import { Container } from "react-bootstrap"
// import TermsDoc from '../Documents/Document.pdf';
import { Helmet } from "react-helmet";
import Breadcrumbs from "../components/Breadcrumbs";
import privacy from '../documents/privacy.pdf'



const Privacy = ({findUser, metaTitle, metaDescription}) => {


    if (findUser) {
        return (
            <>
                <Container
                    fluid={+true}
                    id="privacy-wrapper"
                    style={{
                        backgroundColor: "var(--background-profile)",
                        minHeight: "calc(100vh - 218px)",
                    }}
                >
                    <Helmet>
                        <title>{metaTitle}</title>
                        <meta name="description" content={metaDescription} />
                    </Helmet>
                    <Container className="content-container">
                    <h3>Privacy</h3>
                       <p>You can check out the .find privacy policy</p> <a href={privacy} target="_blank" rel="noreferrer">here.</a>
                    </Container>
                </Container>
            </>
        );
    } else {
        return (
            <>
                <Breadcrumbs />
                <Container
                    fluid={+true}
                    id="terms-wrapper"
                    style={{
                        backgroundColor: "var(--background-profile)",
                        minHeight: "calc(100vh - 218px)",
                    }}
                >
                    <Helmet>
                        <title>{metaTitle}</title>
                        <meta name="description" content={metaDescription} />
                    </Helmet>
                    <Container className="content-container pt-3">
                    <h3>Privacy</h3>
                       <p>You can check out the .find privacy policy <a href={privacy} target="_blank" rel="noreferrer">here.</a></p>
                    </Container>
                </Container>
            </>
        );
    }




}

export default Privacy



